import { PayloadAction, createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { UserDetail } from 'types'
import { fetchUserDetail as getUserDetail } from 'services/user'

type InitialState = UserDetail | undefined

const initialState: InitialState = null

export const fetchUserDetail = createAsyncThunk(
  'userDetail',
  async (userId: number) => {
    return await getUserDetail(userId, true)
  },
)

export const userDetailSlice = createSlice({
  name: 'userDetail',
  initialState: initialState,
  reducers: {
    updateUserDetail: (state, action: PayloadAction<UserDetail>) => {
      return action.payload
    },
  },
  extraReducers(builder) {
    builder.addCase(
      fetchUserDetail.fulfilled,
      (state, action: PayloadAction<UserDetail>) => {
        return action.payload
      },
    )
  },
})

export const { updateUserDetail } = userDetailSlice.actions
export default userDetailSlice.reducer
